"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSigProposalStatusEnum = exports.SettlementDirectionEnum = exports.ClaimScopeTypeEnum = void 0;
var ClaimScopeTypeEnum;
(function (ClaimScopeTypeEnum) {
    ClaimScopeTypeEnum["Identity"] = "Identity";
    ClaimScopeTypeEnum["Asset"] = "Asset";
    ClaimScopeTypeEnum["Custom"] = "Custom";
})(ClaimScopeTypeEnum = exports.ClaimScopeTypeEnum || (exports.ClaimScopeTypeEnum = {}));
var SettlementDirectionEnum;
(function (SettlementDirectionEnum) {
    SettlementDirectionEnum["None"] = "None";
    SettlementDirectionEnum["Incoming"] = "Incoming";
    SettlementDirectionEnum["Outgoing"] = "Outgoing";
})(SettlementDirectionEnum = exports.SettlementDirectionEnum || (exports.SettlementDirectionEnum = {}));
var MultiSigProposalStatusEnum;
(function (MultiSigProposalStatusEnum) {
    MultiSigProposalStatusEnum["Active"] = "Active";
    MultiSigProposalStatusEnum["Approved"] = "Approved";
    MultiSigProposalStatusEnum["Success"] = "Success";
    MultiSigProposalStatusEnum["Failed"] = "Failed";
    MultiSigProposalStatusEnum["Rejected"] = "Rejected";
    MultiSigProposalStatusEnum["Deleted"] = "Deleted";
})(MultiSigProposalStatusEnum = exports.MultiSigProposalStatusEnum || (exports.MultiSigProposalStatusEnum = {}));
//# sourceMappingURL=typesV1.js.map